import { HStack, VStack } from 'native-base';
import { useTranslation } from 'react-i18next';

import { Button, Text } from '@pimm/base';

type ConfirmIncompleteTaskProps = {
  onClose?: () => void;
  onConfirm?: () => void;
};

export const ConfirmIncompleteTask = (props: ConfirmIncompleteTaskProps) => {
  const { t } = useTranslation();

  return (
    <VStack space={4}>
      <Text color="black" fontWeight={600} size="xl" lineHeight="sm">
        {t('cleaning_task:change_status')}
      </Text>
      <Text color="gray.900" fontWeight={400} size="md" lineHeight="sm">
        {t('cleaning_task:do_you_want_to_change_status_to_incomplete')}
      </Text>

      <HStack space={2}>
        <Button flex={1} variant="unstyled" onPress={props.onClose}>
          {t('cleaning_task:cancel')}
        </Button>
        <Button flex={1} onPress={props.onConfirm}>
          {t('cleaning_task:confirm')}
        </Button>
      </HStack>
    </VStack>
  );
};
